// Begin action types
export const SET_JUMBOTRON_TITLE = 'SET_JUMBOTRON_TITLE'
export const SET_IS_LOADING = 'SET_IS_LOADING'
export const SET_SEARCH_LOADER = 'SET_SEARCH_LOADER'
// End action types

export const setJumbotronTitle = (title) => ({
  type: SET_JUMBOTRON_TITLE,
  title
});

export const setIsLoading = (isLoading) => ({
  type: SET_IS_LOADING,
  isLoading
});

export const setSearchLoader = (searchLoader) => ({
  type: SET_SEARCH_LOADER,
  searchLoader
});
